module.exports = __webpack_public_path__ + "img/benifit-1.9fd05a7.png";